import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
const DEPARTMENTS_REQUEST_TIMEOUT = 15000;
let inFlightDepartmentsRequest = null;

export const getServiceDepartments = () => {
  if (inFlightDepartmentsRequest) return inFlightDepartmentsRequest;

  inFlightDepartmentsRequest = (async () => {
    try {
      const token = Cookies.get("Bearer");

      const response = await axios.get(
        `${FIRMFLOWURL}api/Department/firm/`,
        {
          headers: { Authorization: token },
          timeout: DEPARTMENTS_REQUEST_TIMEOUT,
        }
      );

      return { ...response, success: true };
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        Cookies.remove("Bearer");
        window.location.replace("/");
      }
      return {
        success: false,
        status,
        message: err.response?.data?.message || err.message,
      };
    }
  })().finally(() => {
    inFlightDepartmentsRequest = null;
  });

  return inFlightDepartmentsRequest;
};
